class LocalStorageUtils {
  public getObjectItem<T>(key: string, defaultValue: T): T {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  }

  public getBooleanItem(key: string, defaultValue: boolean): boolean {
    const item = localStorage.getItem(key);
    if (!item) {
      return defaultValue;
    }
    return item === 'true';
  }

  public getNumberItem(key: string, defaultValue: number): number {
    const item = localStorage.getItem(key);
    if (!item) {
      return defaultValue;
    }
    return +item;
  }

  public setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public removeItems(key: string): void {
    localStorage.removeItem(key);
  }
}

export const localStorageUtils = new LocalStorageUtils();
